export enum EPropertyType {
  HOUSE = 'Casa',
  DUPLEX_HOUSE = 'Casa Duplex',
  APARTMENT = 'Departamento',
  OFFICE = 'Oficina',
  CONSULTING_ROOM = 'Consultorio',
  WAREHOUSE = 'Bodega',
  INDUSTRIAL_BUILDING = 'Nave industrial',
  SHOP = 'Local',
  SHOP_SHOPPING_CENTER = 'Local en centro comercial',
  TERRAIN = 'Terreno/Lote',
  RANCH = 'Rancho/Hacienda',
  BUILDING = 'Edificio',
  HOTEL = 'Hotel',
  EVENT_HALL = 'Salon/Terraza de eventos',
  COTTAGE = 'Cabaña',
  OTHER = 'Otro'
}

export enum EBusinessType {
  SALE = 'Venta',
  LEASE = 'Renta',
  PRESALE = 'Preventa'
}
